var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "div",
          {
            staticClass: "flex-between-center mb-20",
            on: {
              click: function ($event) {
                _vm.open = !_vm.open
              },
            },
          },
          [
            _c("div", { staticClass: "color-grey1 text-uppercase text-bold" }, [
              _vm._v("Remise et frais de port"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pull-right" },
              [_c("collapse-indicator", { attrs: { open: _vm.open } })],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c("collapse-transition", [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.open,
                  expression: "open",
                },
              ],
            },
            [
              _c("div", { staticClass: "flex-start-center p-10 radius-5" }, [
                _c("div", { staticClass: "has-float-label" }, [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.percent,
                          expression: "percent",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Remise" },
                      domProps: { value: _vm.percent },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.percent = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "input-group-addon bg-white border-0" },
                      [_vm._v(" % ")]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "has-float-label" }, [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.amount,
                          expression: "amount",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Montant" },
                      domProps: { value: _vm.amount },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.amount = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "input-group-addon bg-white border-0" },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t" +
                            _vm._s(_vm.order.Currency) +
                            "\n\t\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex-start-center p-10 radius-5" }, [
                _c("div", { staticClass: "has-float-label" }, [
                  _c("span", [_vm._v("Frais de port")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "has-float-label" }, [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.shippingFee,
                          expression: "shippingFee",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Montant" },
                      domProps: { value: _vm.shippingFee },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.shippingFee = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "input-group-addon bg-white border-0" },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t" +
                            _vm._s(_vm.order.Currency) +
                            "\n\t\t\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.promoCodeErrorMsg
                ? _c("div", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.promoCodeErrorMsg)),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }